import { DAY_LOWERCASE, DAY_PASCAL, DAY_TRUNCATED } from '../constants';

const mapDayToNumber = (
  day: DAY_PASCAL | DAY_LOWERCASE | DAY_TRUNCATED
): number => {
  switch (day) {
    case DAY_PASCAL.SUNDAY || DAY_LOWERCASE.SUNDAY || DAY_TRUNCATED.SUN:
      return 0;
    case DAY_PASCAL.MONDAY || DAY_LOWERCASE.MONDAY || DAY_TRUNCATED.MON:
      return 1;
    case DAY_PASCAL.TUESDAY || DAY_LOWERCASE.TUESDAY || DAY_TRUNCATED.TUE:
      return 2;
    case DAY_PASCAL.WEDNESDAY || DAY_LOWERCASE.WEDNESDAY || DAY_TRUNCATED.WED:
      return 3;
    case DAY_PASCAL.THURSDAY || DAY_LOWERCASE.THURSDAY || DAY_TRUNCATED.THU:
      return 4;
    case DAY_PASCAL.FRIDAY || DAY_LOWERCASE.FRIDAY || DAY_TRUNCATED.FRI:
      return 5;
    case DAY_PASCAL.SATURDAY || DAY_LOWERCASE.SATURDAY || DAY_TRUNCATED.SAT:
      return 6;
    default:
      return 0;
  }
};

export default mapDayToNumber;
